import { isValidCalendarDate, parseCalendarDate } from "./calendar-date.helper";
import ProductGroup from "./product-group.model";

export function cloneProductGroups(groups: ProductGroup[]): ProductGroup[] {
  return groups.map((group) => {
    const copy = new ProductGroup(
      group.id,
      group.period,
      group.name,
      group.internationalDueDate &&
        parseCalendarDate(group.internationalDueDate),
      group.domesticDueDate && parseCalendarDate(group.domesticDueDate),
      group.products
    );
    copy.isNew = group.isNew;
    return copy;
  });
}

function dateInYear(value: Date, year: number): Date {
  const shifted = new Date(year, value.getMonth(), value.getDate());
  return shifted.getMonth() === value.getMonth() &&
    shifted.getDate() === value.getDate()
    ? shifted
    : new Date(NaN);
}

export function copyProductGroups(
  groups: ProductGroup[],
  periodId: string,
  createId: () => string
): ProductGroup[] {
  const year = new Date().getFullYear();

  return groups.map(
    (group) =>
      new ProductGroup(
        createId(),
        periodId,
        group.name,
        group.internationalDueDate &&
          dateInYear(group.internationalDueDate, year),
        group.domesticDueDate && dateInYear(group.domesticDueDate, year),
        group.products
      )
  );
}

export function validateGroupDraft(groups: ProductGroup[]): string[] {
  const errors: string[] = [];
  const assigned = new Set<string>();

  groups.forEach((group, index) => {
    const label = group.name.trim() || `Group ${index + 1}`;

    if (!group.name.trim()) {
      errors.push(`Group ${index + 1} needs a name.`);
    }

    if (!group.products.length) {
      errors.push(`${label} needs at least one product.`);
    }

    if (!isValidCalendarDate(group.internationalDueDate)) {
      errors.push(`${label} needs a valid international due date.`);
    }

    if (!isValidCalendarDate(group.domesticDueDate)) {
      errors.push(`${label} needs a valid domestic due date.`);
    }

    group.products.forEach((id) => {
      if (assigned.has(id)) {
        errors.push(`Product ${id} belongs to more than one Holiday group.`);
      }

      assigned.add(id);
    });
  });

  return Array.from(new Set(errors));
}
